export const OVERVIEW_DETAILS_LIST = [
  {
    title: "ADDRESS",
    key: "location",
  },
  {
    title: "APPLIANCE",
    key: "properties.appliance_type",
  },
  {
    title: "FIRMWARE",
    key: "properties.daemon_version",
  },
  {
    title: "STATUS",
    key: "properties.state.state_message",
  },
  {
    title: "LAST UPDATED BY",
    key: "last_updated_by",
  },
  {
    title: "LAST SEEN",
    key: "properties.last_seen",
  },
  {
    title: "IN-SERVICE DATE",
    key: "date_claimed",
  },
  {
    title: "CLAIM BY",
    key: "claimed_by",
  },
];
